export const getLocale = () => {
  const currentLocale =
    navigator?.languages?.[0] ?? navigator?.language ?? "en-US";
  if (typeof currentLocale === "string" && !currentLocale.includes("-u-nu-")) {
    return `${currentLocale}-u-nu-latn`;
  }
  return currentLocale;
};
